import { render, staticRenderFns } from "./LibTreeItem.vue?vue&type=template&id=54b3cb60&scoped=true&"
import script from "./LibTreeItem.vue?vue&type=script&lang=ts&"
export * from "./LibTreeItem.vue?vue&type=script&lang=ts&"
import style0 from "./LibTreeItem.vue?vue&type=style&index=0&id=54b3cb60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b3cb60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
